<template lang="pug">
  main.about(v-if="settings")
    header.header
      main-menu
      carousel(
        :perPage="1"
        :autoplay="true"
        :autoplayHoverPause="true"
        :loop="true"
        :autoplayTimeout="6000"
        paginationColor="#f8f8f8"
        paginationActiveColor="#5477a3"
      )
        slide(
          v-for="(slide, index) in settings.sections.about.carousel"
          :key="index"
          :style="`background-image:url(${slide})`"
        )
    section.section
      div.intro.container
        h1.title {{ settings.sections.about.title }}
        p {{ settings.sections.about.description }}
      div.wrapper-people
        div.container
          h1 people
          div.columns.people
            div.column(v-for="(item, index) in people" :class="{close: index !== activeItem}")
              div.picture
                img(v-if="item.foto" v-bind:src="item.foto" width="264" height="150" alt="foto")
                img(v-else src="static/img/placeholder-people.png" width="264" height="150" alt="foto")
              h2 {{ item.nome }} {{ item.cognome }}
              h3 {{ item.tipo }}
              h4(v-if="item.email_to" class="mail") {{ item.email_to }}
              h4(class="phone") {{ item.tel }}
              div(class="curriculum-toggle" @click="openCV(index)")
                span
                span
              div.cv
                p {{ item.cv }}
                a(v-if="item.www" :href="item.www" target="new") See Curriculum
      div.wrapper-partners
        div.container
          h1 main sponsors
          h2(v-if="settings.sections.about.partners" v-html="settings.sections.about.partners")
          div.columns.partners
            a.logo.column(v-for="partner in partners" :href="partner.link" target="_blank")
              div.image
                img(:src="partner.logo" width="72" height="96")
              div.partner-name
                p {{ partner.nome }}
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import { mapState } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'about',
  metaInfo: {
    title: 'About'
  },
  components: {
    'main-menu': MainMenu,
    Carousel,
    Slide
  },
  computed: mapState([
    'people',
    'partners',
    'settings'
  ]),
  data () {
    return {
      msg: 'ABOUT',
      activeItem: -1
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_PEOPLE_LIST')
    this.$store.dispatch('LOAD_PARTNERS_LIST')
  },
  methods: {
    openCV (index) {
      console.log(index)
      this.activeItem = (this.activeItem === index) ? null : index
    },
    closeCV () {
      this.activeItem = -1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.people {
  .column {
    position: relative;
    &:hover {
      .cv {
        height: auto;
        overflow: auto;
      }
    }
  }
}

.cv {
  position: absolute;
  height: 0;
  overflow: hidden;
  background: white;
  z-index: 1;
  p {
    padding: 1em;
    font-size: .9em;
  }
  &:hover {
    height: auto;
    overflow: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/About.vue